import React, { useEffect, useState } from "react";
import Popup from "devextreme-react/popup";

function CustomModal({
	title,
	isVisible,
	onAccept,
	onReject,
	onCancel,
	children,
	width,
	height,
	onShown,
	hideOnOutsideClick,
	acceptLabel,
	closeLabel,
	style,
}) {
	const [result, setResult] = React.useState(null);
	const [visible, setVisible] = React.useState(isVisible);
	React.useEffect(() => {
		setVisible(isVisible);
	}, [isVisible]);

	React.useEffect(() => {
		if (result != null) {
			switch (result) {
				case 1:
					if (onAccept) onAccept();
					break;
				case -1:
					if (onReject) onReject();
					break;
				case 0:
					if (onCancel) onCancel();
					break;
			}
			setResult(null);
			setVisible(false);
		}
	}, [result, onAccept, onReject, onCancel]);

	if (!visible) {
		return <></>;
	}

	return (
		<Popup
			visible={true}
			hideOnOutsideClick={hideOnOutsideClick ?? true}
			dragEnabled={false}
			onShown={onShown}
			title={title}
			animation={null}
			resizeEnabled={false}
			onHiding={() => {
				setResult(0);
			}}
			maxWidth={"90vw"}
			width={width ?? "80vw"}
			maxHeight={"90vh"}
			height={height ?? "80vh"}
		>
			<div
				style={{
					height: "100%",
					width: "100%",
					display: "flex",
					flexDirection: "column",
					minHeight: 0,
					...style,
				}}
			>
				<div
					style={{
						flex: "1 1 auto",
						minHeight: 0,
						overflowY: "auto",
						overflowX: "hidden",
						paddingRight: "4px",
					}}
				>
					{children}
				</div>
				<div
					style={{
						flex: "0 0 auto",
						marginTop: "12px",
						paddingTop: "8px",
						backgroundColor: "#fff",
						borderTop: "1px solid #eee",
					}}
				>
					{onCancel !== undefined && (
						<button
							className="btn action-btn"
							style={{ float: "right", marginLeft: "1em" }}
							onClick={() => setResult(0)}
						>
							{closeLabel ?? "Cancel"}
						</button>
					)}
					{onReject !== undefined && (
						<button
							className="btn  action-btn text-white"
							style={{
								float: "right",
								backgroundColor: "grey",
								marginLeft: "1em",
							}}
							onClick={() => setResult(-1)}
						>
							Reject
						</button>
					)}
					{onAccept !== undefined && (
						<button
							className="btn  action-btn orange-base text-white"
							style={{ float: "right" }}
							onClick={() => setResult(1)}
						>
							{acceptLabel ?? "Accept"}
						</button>
					)}
				</div>
			</div>
		</Popup>
	);
}

export default CustomModal;
